import React, { useEffect } from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Features from "../components/landing/Features";
import Stats from "../components/landing/Stats";
import Games from "../components/landing/Games";
import Providers from "../components/landing/Providers";
import Payments from "../components/landing/Payments";
import FAQ from "../components/landing/FAQ";
import SEOContent from "../components/landing/SEOContent";
import Testimonials from "../components/landing/Testimonials";
import CTA from "../components/landing/CTA";
import Footer from "../components/landing/Footer";
import WhatsAppFloat from "../components/landing/WhatsAppFloat";

export default function LandingPage() {
    useEffect(() => {
        document.title =
            "PUSATCUAN: Platform Hiburan Digital Terbaik & Link Resmi Terpercaya";
    }, []);

    return (
        <main data-testid="landing-page" className="bg-[#050505] text-white">
            <Header />
            <Hero />
            <Stats />
            <Features />
            <Games />
            <Providers />
            <Payments />
            <SEOContent />
            <Testimonials />
            <FAQ />
            <CTA />
            <Footer />
            <WhatsAppFloat />
        </main>
    );
}
